<template>
    <div>
        <PullContainer ref="pullContainerRef"  :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

                        </ReturnNavBar>
                        <div class="mobile_head_operate">
                          <p @click="handleClickPurchaseAdd"><i class="el-icon-plus"></i> 新建采购</p>
                        </div>
                    </div>
                    <div class="mobile_search">
                        <van-search
                                v-model="searchForm.keyword"
                                placeholder="请输入查询内容"
                                @clear="handleClickSearch"
                                @search="handleClickSearch">
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="purchase_management_container mobile_container">
                        <ul  v-infinite-scroll="onLoadList">
                            <li v-for="item in tableData">
                                <div class="field_item">
                                    <span class="field_name">采购单编号：</span>
                                    <span class="field_value" v-text="item.purchase_num"></span>

                                    <span class="status_text status0"  v-if="item.status == 0 ">审批中</span>
                                    <span class="status_text status1"  v-if="item.status == 1 ">已通过</span>
                                    <span class="status_text status2"  v-if="item.status == 2 ">已拒绝</span>
                                    <span class="status_text status3"  v-if="item.status == 3 ">已撤销</span>
                                    <span class="status_text status4"  v-if="item.status == 4 ">部分退货</span>
                                    <span class="status_text status5"  v-if="item.status == 5 ">全部退货</span>


                                    <span class="handle" @click="handleClickItem(item)">
                                        <i class="iconfont icon-gengduo"></i>
                                    </span>
                                </div>
                                <div class="field_item">
                                    <span class="field_name">发起人：</span>
                                    <span class="field_value ">
                                        <span class="mobile_head_user" v-if="item.userinfo" @click="handleClickUserDetail(item.userinfo.uid)">
                                             <img :src="item.userinfo.avatar ? item.userinfo.avatar : 'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'" alt="">
                                             <span class="ellipsis" v-text="item.userinfo.name"></span>
                                        </span>
                                    </span>
                                </div>
                                <div class="field_item">
                                    <span class="field_name">供应商：</span>
                                    <span class="field_value" v-text="item.supplier_name.value"></span>
                                </div>
                                <div class="field_item">
                                    <span class="field_name">付款总金额：</span>
                                    <span class="field_value" v-text="item.total_price.text"></span>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <ListAdvancedFiltering
                            v-if="searchPopupShow"
                            ref="listAdvancedFiltering"
                            :field_form="'purchases'"
                            :system_fields="systemFilterFields"
                            @sendFilterData="getFilterData"
                    />

                    <userDetailDialog
                            v-if="userDetailPopupShow"
                            :userDetailPopupShow.sync="userDetailPopupShow"
                            :userId="userDetailId"
                    />

                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" z-index="1000" v-if="handleRadioPicker" :show="handleRadioPicker" @click="handleRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li class="radio_option_item" v-if="activeItem.status == 0"  @click="handleClickItemWithdraw()">撤销审批</li>
                                <li class="radio_option_item" v-if="activeItem.status == 2 || activeItem.status == 3"  @click="handleClickItemReissue()">重新发起</li>
                                <li class="radio_option_item" v-if="activeItem.status == 1 || activeItem.status == 4"  @click="handleClickItemReturn()">退货</li>
                                <li class="radio_option_item"  @click="handleClickItemDetail()">详情</li>
                            </ul>
                            <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>


                </div>
            </template>
        </PullContainer>
    </div>

</template>
<script>
import {PurchaseList} from '@/api'
import PullContainer from '@/components/mComponents/PullContainer.vue'
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import {mapState} from "vuex";
import {pagination} from '@/mixins'
export default {
    name: 'Purchase',
    components: {
        PullContainer,
        ReturnNavBar,
        ListAdvancedFiltering,
        userDetailDialog
    },
    mixins: [pagination],
    data () {
        return {
            searchForm:{
                keyword:''
            },
            systemFilterFields: [
                {
                    field_type: "date_range",
                    field_key: "purchases.pre_due_date",
                    is_system: 1,
                    date_type:'daterange',
                    field_name: "创建时间",
                    system_type: "system",
                    field_value_type: "array",
                },
                {
                    field_type: "radio",
                    field_key: "purchases.status",
                    is_system: 1,
                    field_name: "单据状态",
                    system_type: "system",
                    field_value_type: "int",
                    options: [
                        { value: 0, label: "审批中" },
                        { value: 1, label: "已通过" },
                        { value: 2, label: "已拒绝" },
                        { value: 3, label: "已撤销" },
                        { value: 4, label: "部分退货" },
                        { value: 5, label: "全部退货" },
                    ],
                },
            ], //单据状态筛选/预交日期筛选/发起人
            custom_filter: {}, // 高级筛选确认条件
            userDetailPopupShow:false,
            userDetailId: 0,
            tableData:[],
            handleRadioPicker:false,
            handleItemList:[
                {name:'重新发起',value:'reissue'},
                {name:'撤回审批',value:'withdraw'},
                {name:'退货',value:'return'},
                {name:'详情',value:'detail'},
            ],
            activeItem:null
        }
    },
    computed: {
        ...mapState(["searchPopupShow"]),
    },
    mounted () {
        this.getTableData()
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true
                this.handleClickSearch()
            }
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.tableData =  []
            this.getTableData()
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.handleClickSearch();
        },
        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize:this.pagination.pageSize,
                keyword:this.searchForm.keyword
            }
            PurchaseList(postData).then(res => {
                if (res.code === 200) {
                    let {data,total} = res.data
                    this.tableData = this.tableData.concat(data)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                    this.loading = false
                    if(this.pullDownLoading){
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                    }
                }

            })
        },
        // 新建采购
        handleClickPurchaseAdd(){
            this.$router.push({
                name:'purchase_add'
            })
        },
        // 选择三个点
        handleClickItem(item){
            this.activeItem = item
            this.handleRadioPicker = true
        },
        // 重新发起
        handleClickItemReissue(){
            this.$router.push({
                name:'purchase_edit',
                query:{
                    purchase_id:this.activeItem.purchase_id
                }
            })
        },
        // 撤回审批
        handleClickItemWithdraw(){},
        // 退货
        handleClickItemReturn(){
            this.$router.push({
                name:'purchase_return_goods',
                query:{
                    purchase_id:this.activeItem.purchase_id
                }
            })
        },
        // 详情
        handleClickItemDetail(){
            this.$router.push({
                name:'purchaseDetail',
                query:{
                    purchase_id:this.activeItem.purchase_id
                }
            })
        },
    },

}
</script>

<style lang="scss" scoped>
    .mobile_head_operate{
        color: rgba(41, 144, 255, 1);
        font-size: 12px;
        p{
            line-height: 24px;
        }
        i{
            margin-right: 4px;
            font-size: 14px;
        }
    }
    .mobile_search{
        width: 100%;
        padding: 6px 16px;
        background: rgb(255, 255, 255);
        .van-search{
            padding: 0;
            border-radius: 6px;
            background-color: rgb(243, 243, 243);
            overflow: hidden;
        }
        .icon-shaixuan{
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
        }
    }
    .purchase_management_container{
        width: 100%;
        padding: 10px 16px;
        box-sizing: border-box;
        ul{
            width: 100%;
            li{
                width: 100%;
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);
                margin-bottom: 8px;
                padding: 10px 10px 2px 10px;
                box-sizing: border-box;
                .field_item{
                    width: 100%;
                    line-height: 22px;
                    font-size: 14px;
                    color: rgba(102, 102, 102, 1);
                    position: relative;
                    margin-bottom: 8px;
                    .status_text{
                        margin-left: 10px;
                        padding: 0 10px;
                        line-height: 22px;
                        display: inline-block;
                        border-radius: 6px;
                        font-size: 12px;
                        &.status0{
                                background: rgba(240, 170, 50, 0.15);
                                color: rgba(240, 170, 50, 1);
                            }

                        &.status1{
                            background: rgba(90, 179, 51, 0.15);
                            color: rgba(90, 179, 51, 1);
                        }
                        &.status2{
                            background: rgba(228, 65, 68, 0.15);
                            color: rgba(228, 65, 68, 1);
                        }
                        &.status3{
                            background: rgba(153, 153, 153, 0.15);
                            color: rgba(153, 153, 153, 1);
                        }
                        &.status4{
                            background: rgba(247, 187, 152, 0.15);
                            color: rgba(247, 187, 152, 1);
                        }
                        &.status5{
                            background: rgba(240, 120, 50, 0.15);
                            color: rgba(240, 120, 50, 1);
                        }
                    }
                    .handle{
                        line-height: 22px;
                        float: right;
                    }
                    .mobile_head_user {
                        font-size: 0;
                        line-height: 22px;
                        height: 22px;
                        background: #EDF0F4;
                        border-radius: 22px;
                        display: inline-block;
                        vertical-align: middle;
                        img {
                            width: 22px;
                            min-width: 22px;
                            height: 22px;
                            border-radius: 50%;
                        }
                        span {
                            flex: 1;
                            font-size: 14px;
                            color: rgba(51, 51, 51, 1);
                            font-weight: bold;
                            display: inline-block;
                            padding: 0 8px;
                            box-sizing: border-box;
                            max-width: 78px;
                        }
                    }
                }

            }
        }
    }
</style>
